document.addEventListener('DOMContentLoaded', function () {

  var main = new Splide( '.clean-design-v1 .mainProduct-gallery', {
    type: 'slide',
    pagination: false,
    arrows    : false,
  } );

  var thumbnails = new Splide( '.clean-design-v1 .mainProduct-thumbs', {
    perPage     : 5,
    gap         : 10,
    rewind      : true,
    pagination  : false,
    isNavigation: true,
    arrows    : false,
    breakpoints : {
      600: {
        fixedWidth : 60,
        fixedHeight: 60,
      },
    },
  } );

  main.sync( thumbnails );
  main.mount();
  thumbnails.mount();

  const tabForms = document.querySelectorAll('.clean-design-v1 .bcolors-form');
  const gift_wrappers = document.querySelectorAll('.clean-design-v1 .bcolors-gift-wrapper');
  const main_cta = document.querySelector('.clean-design-v1 .bcolors-add-to-cart');

  const selectOption = (option) => {
    const form = option.closest('.bcolors-form');
    const addToCartBtn = form.querySelectorAll('.bcolors-add-to-cart');
    const variant_selector = form.querySelector('.bcolors-variant-selector select');
    option.classList.add('selected');
    const selectedPrice = option.querySelector('.final-price').textContent;
    addToCartBtn.forEach(btn => {
      btn.textContent = `Add to Cart - ${selectedPrice}`;
    });
    let giftCount = 0;
    
    const variant_id_input = form.querySelector('.ptabs-variant-id');
    const selling_plan_id_input = form.querySelector('.ptabs-selling-plan');

    gift_wrappers.forEach(gift_wrapper => {
      giftCount = 0;
      gift_wrapper.querySelectorAll('.bcolors-gift').forEach((gift, index) => {
        if ( option.dataset['gift' + ( index + 1 )] ) { 
          gift.classList.add('unlocked');
          giftCount++;
        } else { 
          gift.classList.remove('unlocked');
        }
      });

      if ( giftCount ) {
        gift_wrapper.classList.remove('empty');
      } else {
        gift_wrapper.classList.add('empty');
      }
    });

    const option_image = option.querySelector('img');
    if ( option_image ) {
      thumbnails.go(0);
      const firstSlide = document.querySelector('#mainProduct-gallery .splide__slide:first-child img');
      firstSlide.src = option_image.src;
      firstSlide.srcset = '';
    }

    variant_id_input.value = variant_selector ? variant_selector.value : option.dataset.variantId || '';
    selling_plan_id_input.value = option.dataset.sellingPlan || '';
  }

  tabForms.forEach(form => {
    const tabSelectors = form.querySelectorAll('.bcolors-tabs-titles button');
    const tabContents = form.querySelectorAll('.bcolors-tabs-panel');
    
    const optionSelectors = form.querySelectorAll('.bcolors-tabs-option');
    const variant_selector = form.querySelector('.bcolors-variant-selector select');

    
    optionSelectors.forEach(option => {
      option.addEventListener('click', function () {
        optionSelectors.forEach(o => o.classList.remove('selected'));
        selectOption(this);
      });
  
      if ( option.classList.contains('selected') ) {
        selectOption(option);
      }
    });

    tabSelectors.forEach(tab => {
      tab.addEventListener('click', function () {
        tabSelectors.forEach(t => t.classList.remove('selected'));
        this.classList.add('selected');
        const index = Array.from(tabSelectors).indexOf(this);
        tabContents.forEach(content => content.classList.remove('selected'));
  
        const selectedTab = tabContents[index];
        selectedTab.classList.add('selected');
  
        const selectedOption = selectedTab.querySelector('.bcolors-tabs-option.selected');
        
        if (!selectedOption) {
          const firstOption = selectedTab.querySelector('.bcolors-tabs-option');
          if (firstOption) {
            selectOption(firstOption)
          }
        } else {
          selectOption(selectedOption);
        }
      });
    });

    if ( variant_selector ) {
      variant_selector.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const variantTitle = selectedOption.textContent;
        const variantImage = document.querySelector(`#mainProduct-thumbs img[alt="${variantTitle}"]`);
        if ( variantImage ) {
          const variantLi = variantImage.closest('li');
          const variantIndex = Array.from(thumbnails.Components.Elements.slides).indexOf(variantLi);
          thumbnails.go(variantIndex);
        }
        variant_id_input.value = variant_selector.value;
      });
    }
    
  });

  const tabs = document.querySelectorAll('.clean-design-v1 .mpd_tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const content = this.querySelector('.mpd_tab-content');
      const isActive = content.style.display === 'block';
      
      // Hide all tab contents and remove selected class
      document.querySelectorAll('.mpd_tab-content').forEach(c => {
        c.style.display = 'none';
      });
      tabs.forEach(t => t.classList.remove('selected'));

      // Toggle the clicked tab content and add selected class
      content.style.display = isActive ? 'none' : 'block';
      if (!isActive) {
        this.classList.add('selected');
      }
    });
  });

  window.addEventListener("scroll", () => {
    if (main_cta !== null) {
      if (!isScrolledIntoView(main_cta)) {
        if (!document.body.classList.contains("sticky-add-to-cart")) {
          document.body.classList.add("sticky-add-to-cart");
        }
      } else {
        if (document.body.classList.contains("sticky-add-to-cart")) {
          document.body.classList.remove("sticky-add-to-cart");
        }
      }
    }
  });

  const isScrolledIntoView = (/** @type {HTMLElement} */ elem) => {
    const docViewTop = window.scrollY - 200;
    const elemTop = elem.offsetTop;
    return elemTop >= docViewTop;
  };

  const nadCtas = document.querySelectorAll('.cta-button');
  if ( nadCtas ) {
    nadCtas.forEach(cta => {
      cta.addEventListener('click', function(e) {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
        });
        e.preventDefault();
      });
    });
  }

});